import { authFailure, sharedAuthMessage } from '../../api';

/** What the password reset screens tell the player. */
export const RESET_PASSWORD_MESSAGES = {
  /** On /sign-in, when signing in with the new password didn't work. */
  passwordChanged: 'Your password has been changed. Sign in with your new password.',
  checkFailed: "We couldn't check your link. Try again in a moment.",
  resetFailed: "We couldn't change your password. Try again in a moment.",
  /** When the account's providers couldn't be checked, for any reason: the form is never shown without the check. */
  providersCheckFailed: 'Something went wrong. Try again.',
} as const;

/** The alert for a failed call: too many requests and network failures have their own message, all else `fallback`. */
export const resetErrorMessage = (error: unknown, fallback: string): string =>
  sharedAuthMessage(authFailure(error)) ?? fallback;
